import React from 'react';
import { SpecialURLConfig } from '../config';

export const SpecialURLConfigContext = React.createContext<SpecialURLConfig>(null);
